import { useTranslation } from "react-i18next";
import {
  Wrap,
  Inner,
  Left,
  Eyebrow,
  Title,
  Text,
  Actions,
  PrimaryBtn,
  Right,
  Image,
} from "./StorySectionStyles";

export default function StorySection({
  eyebrow,
  title,
  paragraphs,
  ctaLabel,
  onCtaClick,
  imageSrc,
  imageAlt = "",
}) {
  const { t } = useTranslation();

  return (
    <Wrap>
      <Inner>
        <Left>
          <Eyebrow>{eyebrow || t("home.story.eyebrow")}</Eyebrow>
          <Title>{title || t("home.story.title")}</Title>

          {(paragraphs && paragraphs.length > 0
            ? paragraphs
            : [t("home.story.p1"), t("home.story.p2")]
          ).map((p, i) => (
            <Text key={i}>{p}</Text>
          ))}

          {(ctaLabel || t("home.gallery.cta")) && onCtaClick && (
            <Actions>
              <PrimaryBtn
                onClick={onCtaClick}
                aria-label={ctaLabel || t("home.gallery.cta")}
              >
                {ctaLabel || t("home.gallery.cta")} <span aria-hidden>→</span>
              </PrimaryBtn>
            </Actions>
          )}
        </Left>

        {imageSrc && (
          <Right>
            <Image src={imageSrc} alt={imageAlt} loading="lazy" />
          </Right>
        )}
      </Inner>
    </Wrap>
  );
}
